import { useDispatch, useSelector } from "react-redux";
import { paginationSelected } from "../../features/pagination/paginationSlice";

export default function Pagination() {
  const { totalCount } = useSelector((state) => state.videos);
  const { pageNo } = useSelector((state) => state.pagination);
  const dispatch = useDispatch();

  let pageSize = [];
  for (let i = 1; i <= Math.ceil(totalCount / 4); i++) {
    pageSize.push(i);
  }

  return (
    <section className="pt-12">
      <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
        {pageSize?.map((item, index) => (
          <div
            className={`${
              item !== pageNo
                ? "bg-blue-100 text-blue-600 px-4 py-1 rounded-full cursor-pointer"
                : "bg-blue-600 text-white px-4 py-1 rounded-full cursor-pointer"
            }`}
            key={index}
            onClick={() => dispatch(paginationSelected(item))}
          >
            {item}
          </div>
        ))}
      </div>
    </section>
  );
}
